import { userRole, roleBind, getRoleInfo, officialAccountServer } from '@/api/account';
import { placeOrder as placeOrderApi, productList, getPayTypeNew } from '@/api/pay';
import gameConfig from '../../config/offlinePayGame';
import { cyGames } from '@/config/offlinePayGame';

const state = {
  bindVisible: false,
  chargeVisible: false,
  recordVisible: false,
  bindPageVisible: false,
  productVisible: false,
  appkey: '',
  appId: '',
  hiddenTab: false,
  goodsList: [],
  giftList: [],
  orderInfo: {
    name: '商品名',
    price: 12,
    game: '王者国度',
    server: '公测91服',/*  */
    role: '角色名'
  },
  serverList: [],
  roleList: [],
  bindRoleInfo: {},
  currentGoods: {},
  game: '',
  gameFlag: '', // 标识是哪个游戏
  gameIcon: '',
  largeChargeFlag: false,
  payTypeInfo: {},
  largePayTypeInfo: {},
  is_charm: 1,
  largePrice: '',
  showLargeFlag: false
};

const mutations = {
  setState: (state, obj) => {
    state = Object.assign(state, obj);
  }
};

const actions = {
  async getServerInfo({ commit, state }, { user_name }) {
    try {
      const r = await userRole({ user_name, appkey: state.appkey });
      if (r.content && r.content.length) {
        const serverList = [];
        r.content.map(item => {
          const exist = serverList.findIndex(serverItem => serverItem.value === item.server_num);
          if (exist !== -1) {
            serverList[exist].children.push({
              value: item.role_id,
              text: item.role_name,
              user_id: item.user_id
            });
          } else {
            serverList.push({
              text: item.server_name,
              value: item.server_num,
              children: [
                {
                  value: item.role_id,
                  text: item.role_name,
                  user_id: item.user_id
                }
              ]
            });
          }
          this.balance = item.token_coin;
        });
        commit('setState', {
          serverList
        });
      } else {
        commit('setState', {
          serverList: [],
          roleList: []
        });
      }
    } catch (error) {
      commit('setState', {
        serverList: [],
        roleList: []
      });
    }
  },
  async getServer({ commit, state }, { user_name }) {
    const r = await officialAccountServer({ user_name, appkey: state.appkey });
    const serverList = r.content.map(item => {
      return {
        ...item,
        text: item.server_name,
        value: item.server
      };
    });
    commit('setState', {
      serverList,
      roleList: []
    });
  },
  async getUserList({ commit, state }, { user_name, server }) {
    const r = await userRole({ user_name, appkey: state.appkey, server });
    const roleList = r.content.map(item => {
      return {
        ...item,
        text: item.role_name,
        value: item.role_id
      };
    });
    commit('setState', {
      roleList: roleList
    });
  },
  async getUserRole({ commit, state, dispatch }) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    try {
      const r = await getRoleInfo({
        union_id: userInfo.union_id,
        appkey: state.appkey
      });
      commit('setState', {
        bindRoleInfo: r.content,
        bindPageVisible: false,
        productVisible: true
      });
      if (!cyGames.includes(state.gameFlag)) {
        dispatch('getGoodsList');
      }
    } catch (error) {
      commit('setState', {
        bindPageVisible: true,
        bindVisible: true,
        productVisible: false
      });
    }
  },
  async getGoodsList({ commit, state }) {
    const { bindRoleInfo, gameFlag } = state;
    const r = await productList({
      user_id: bindRoleInfo.user_id,
      role_id: bindRoleInfo.role_id,
      appkey: state.appkey,
      server: bindRoleInfo.server
    });
    commit('setState', {
      goodsList: gameConfig[gameFlag].handleGoods(r.content)
    });
  },
  async placeOrder({ state }, pay_type) {
    const { bindRoleInfo, currentGoods, appkey, largeChargeFlag, is_charm, largePrice } = state;
    let params = {
      user_id: bindRoleInfo.user_id,
      money: currentGoods.price,
      appkey: appkey,
      server: bindRoleInfo.server,
      product_name: currentGoods.name,
      product_id: currentGoods.id,
      role_id: bindRoleInfo.role_id,
      role_name: bindRoleInfo.role_name,
      pay_type: pay_type
    };
    if (largeChargeFlag) {
      params = {
        ...params,
        is_large: 1,
        is_charm,
        product_name: '大额支付',
        product_id: '111111',
        money: Number(largePrice)
      }
    }
    const r = await placeOrderApi(params);
    return r;
  },
  async getPayType({ state, commit }, { appkey, roleInfo }) {
    const r = await getPayTypeNew({
      appkey: appkey,
      user_id: roleInfo.user_id,
    });
    const { info, large_info, large_status } = r.content;
    commit('setState', {
      payTypeInfo: info,
      largePayTypeInfo: large_info,
      showLargeFlag: large_status == 1
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
